/* Miloura theme interactions */
(function () {
  'use strict';

  const $ = (s, c) => (c || document).querySelector(s);
  const $$ = (s, c) => Array.from((c || document).querySelectorAll(s));

  /* ---------------------------------------------------- overlay helper */
  function overlay() {
    let el = $('.overlay');
    if (!el) { el = document.createElement('div'); el.className = 'overlay'; document.body.appendChild(el); }
    return el;
  }

  function openPanel(panel) {
    if (!panel) return;
    panel.classList.add('is-open');
    overlay().classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeAll() {
    $$('.is-open').forEach((el) => el.classList.remove('is-open'));
    document.body.style.overflow = '';
  }
  document.addEventListener('click', (e) => { if (e.target.classList.contains('overlay')) closeAll(); });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeAll(); });

  /* -------------------------------------------------------- mobile nav */
  document.addEventListener('click', (e) => {
    const burger = e.target.closest('[data-mobile-nav-open]');
    if (burger) { e.preventDefault(); openPanel($('.mobile-nav')); }
    if (e.target.closest('[data-panel-close]')) { e.preventDefault(); closeAll(); }
  });

  /* ------------------------------------------------------- cart drawer */
  function money(cents) {
    return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  async function refreshCart() {
    try {
      const cart = await fetch('/cart.js').then((r) => r.json());
      const bubble = $('[data-cart-count]');
      if (bubble) { bubble.textContent = cart.item_count; bubble.hidden = cart.item_count === 0; }
      const list = $('[data-cart-items]');
      if (list) {
        list.innerHTML = cart.items.length
          ? cart.items.map((i) => `
              <div class="cart-item">
                <a href="${i.url}"><img src="${i.image ? i.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') : ''}" alt=""></a>
                <div>
                  <a href="${i.url}" class="cart-item__title">${i.product_title}</a>
                  <div class="cart-item__price">${money(i.final_line_price)}</div>
                  <button data-cart-remove="${i.key}" class="cart-item__remove" style="font-size:1.3rem;text-decoration:underline;margin-top:.6rem">Remove</button>
                </div>
              </div>`).join('')
          : '<div class="cart-drawer__empty">Your cart is empty.</div>';
      }
      const total = $('[data-cart-total]');
      if (total) total.textContent = money(cart.total_price);
      const foot = $('[data-cart-foot]');
      if (foot) foot.hidden = cart.items.length === 0;
    } catch (err) { /* no-op */ }
  }

  document.addEventListener('click', async (e) => {
    if (e.target.closest('[data-cart-open]')) {
      e.preventDefault(); await refreshCart(); openPanel($('.cart-drawer'));
    }
    const rm = e.target.closest('[data-cart-remove]');
    if (rm) {
      e.preventDefault();
      await fetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: rm.dataset.cartRemove, quantity: 0 })
      });
      refreshCart();
    }
  });

  // add to cart -> open drawer instead of navigating
  $$('form[action*="/cart/add"]').forEach((form) => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = form.querySelector('[type="submit"]');
      const label = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
      try {
        await fetch('/cart/add.js', { method: 'POST', body: new FormData(form) });
        await refreshCart();
        openPanel($('.cart-drawer'));
      } catch (err) { form.submit(); }
      if (btn) { btn.disabled = false; btn.textContent = label; }
    });
  });

  /* ---------------------------------------------------------- carousel */
  $$('[data-carousel]').forEach((root) => {
    const track = $('[data-carousel-track]', root);
    const prev = $('[data-carousel-prev]', root);
    const next = $('[data-carousel-next]', root);
    if (!track) return;
    const step = () => {
      const first = track.firstElementChild;
      return first ? first.getBoundingClientRect().width + 16 : track.clientWidth * 0.8;
    };
    const sync = () => {
      if (!prev || !next) return;
      prev.disabled = track.scrollLeft < 8;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 8;
    };
    if (prev) prev.addEventListener('click', () => { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', () => { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  });

  /* ------------------------------------------------------- pdp gallery */
  $$('[data-gallery]').forEach((root) => {
    const slides = $('[data-gallery-slides]', root);
    const thumbs = $$('[data-gallery-thumb]', root);
    const prev = $('[data-gallery-prev]', root);
    const next = $('[data-gallery-next]', root);
    if (!slides) return;
    const count = slides.children.length;
    let idx = 0;
    const go = (i) => {
      idx = (i + count) % count;
      slides.style.transform = `translateX(-${idx * 100}%)`;
      thumbs.forEach((t, n) => t.classList.toggle('is-active', n === idx));
      const active = thumbs[idx];
      if (active && active.scrollIntoView) active.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
    };
    thumbs.forEach((t, n) => t.addEventListener('click', () => go(n)));
    if (prev) prev.addEventListener('click', () => go(idx - 1));
    if (next) next.addEventListener('click', () => go(idx + 1));

    // swipe
    let x0 = null;
    slides.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
    slides.addEventListener('touchend', (e) => {
      if (x0 === null) return;
      const dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) go(dx < 0 ? idx + 1 : idx - 1);
      x0 = null;
    }, { passive: true });
    go(0);
  });

  /* -------------------------------------------------- announcement bar */
  $$('[data-announcement]').forEach((root) => {
    const track = $('[data-announcement-track]', root);
    if (!track || track.children.length < 2) return;
    let i = 0;
    setInterval(() => {
      i = (i + 1) % track.children.length;
      track.style.transform = `translateX(-${i * 100}%)`;
    }, 4500);
  });

  /* ----------------------------------------------------------- countdown */
  $$('[data-countdown]').forEach((el) => {
    const target = new Date(el.dataset.countdown).getTime();
    if (isNaN(target)) return;
    const out = {
      days: $('[data-cd-days]', el), hours: $('[data-cd-hours]', el),
      minutes: $('[data-cd-minutes]', el), seconds: $('[data-cd-seconds]', el)
    };
    const pad = (n) => String(Math.max(0, n)).padStart(2, '0');
    const tick = () => {
      const d = target - Date.now();
      if (out.days) out.days.textContent = pad(Math.floor(d / 864e5));
      if (out.hours) out.hours.textContent = pad(Math.floor(d / 36e5) % 24);
      if (out.minutes) out.minutes.textContent = pad(Math.floor(d / 6e4) % 60);
      if (out.seconds) out.seconds.textContent = pad(Math.floor(d / 1e3) % 60);
    };
    tick(); setInterval(tick, 1000);
  });

  /* ------------------------------------------------------ scroll reveal */
  const io = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => {
        entries.forEach((en) => {
          if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 })
    : null;
  $$('.reveal').forEach((el, n) => {
    el.style.transitionDelay = (el.dataset.delay || (n % 4) * 60) + 'ms';
    if (io) io.observe(el); else el.classList.add('is-in');
  });
  // failsafe: never leave content invisible if the observer misfires
  setTimeout(() => $$('.reveal:not(.is-in)').forEach((el) => {
    if (el.getBoundingClientRect().top < window.innerHeight * 1.5) el.classList.add('is-in');
  }), 2000);

  /* --------------------------------------------------- keep me updated */
  const ku = $('#KeepUpdated');
  if (ku) {
    if (!sessionStorage.getItem('ku-dismissed')) ku.hidden = false;
    $('.keep-updated__close', ku).addEventListener('click', () => {
      ku.hidden = true; sessionStorage.setItem('ku-dismissed', '1');
    });
  }

  refreshCart();
})();
